class RelatedProducts extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.setupArrowButtons()
  }

  setupArrowButtons() {
    const leftButton = this.querySelector(".snippet-header button:first-child")
    const rightButton = this.querySelector(".snippet-header button:last-child")
    const carousel = this.querySelector(".featured-collection__inner")

    if (!leftButton || !rightButton || !carousel) return

    const stepPercentage = this.dataset.stepPercentage
      ? Number(this.dataset.stepPercentage) / 100
      : 0.5

    leftButton.addEventListener("click", () => {
      carousel.scroll({
        left: carousel.scrollLeft - carousel.clientWidth * stepPercentage,
        behavior: "smooth",
      })
    })

    rightButton.addEventListener("click", () => {
      carousel.scroll({
        left: carousel.scrollLeft + carousel.clientWidth * stepPercentage,
        behavior: "smooth",
      })
    })
  }
}

customElements.define("related-products", RelatedProducts)
